import { FC } from 'react';

import MesUiGlobalHeader from '@mes-ui/global-header';
import { useAppSelector } from 'hooks';
import { configSelector } from 'selectors';

import '@mes-ui/global-header/styles/index.css';

const GlobalHeader: FC = () => {
  const config = useAppSelector(configSelector);
  // const handleLogout = useCallback(() => {
  //   removeAuthToken();
  //   redirectToChoicePage();
  // }, []);
  const ymEnable = config ? config.YM_ENABLED === true : false;
  return <MesUiGlobalHeader ymEnable={ymEnable} />;
};

export default GlobalHeader;
